import { Injectable, inject } from '@angular/core';
import { HttpEvent, HttpInterceptor, HttpHandler, HttpRequest } from '@angular/common/http';

import { Observable } from 'rxjs';
import { BaseParamsService } from '@app/core/base-params.service';

@Injectable()
export class SourceInterceptor implements HttpInterceptor {
  private baseParamsService = inject(BaseParamsService);


  public intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if (this.baseParamsService.source) {
      req = req.clone({
        headers: req.headers.set('x-source', this.baseParamsService.source)
      });
    }
    return next.handle(req);
  }
}
